import React from "react";

import "./etiquetas.scss";

export interface IEtiquetas {
  etiquetas: string[];
}

const Etiquetas = (props: IEtiquetas) => {
  const { etiquetas } = props;
  if (!etiquetas?.length) return "";
  return (
    <div className="etiquetas">
      <p>Etiquetas:</p>
      {etiquetas.map((etiqueta, key) => (
        <span key={key}>{etiqueta}</span>
      ))}
    </div>
  );
};

export default Etiquetas;
